"use strict";
// Copyright (C) 2017-2026 Smart code 203358507
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var core_1 = require("stremio/core");
var usePlayOnDevice = function (stream) {
    var core = (0, core_1.useCore)();
    var streamingUrl = (0, react_1.useMemo)(function () {
        var _a, _b, _c;
        return (_c = (_b = (_a = stream === null || stream === void 0 ? void 0 : stream.deepLinks) === null || _a === void 0 ? void 0 : _a.externalPlayer) === null || _b === void 0 ? void 0 : _b.streaming) !== null && _c !== void 0 ? _c : null;
    }, [stream]);
    var playOnDevice = (0, react_1.useCallback)(function (deviceId, time) {
        if (time === void 0) { time = 0; }
        if (streamingUrl) {
            core.transport.dispatch({
                action: 'StreamingServer',
                args: {
                    action: 'PlayOnDevice',
                    args: {
                        device: deviceId,
                        source: streamingUrl,
                        // Start-position seeking requires a server version that accepts the time property.
                        time: Math.max(0, Math.round(time !== null && time !== void 0 ? time : 0)),
                    }
                }
            });
        }
    }, [streamingUrl]);
    return { streamingUrl: streamingUrl, playOnDevice: playOnDevice };
};
exports.default = usePlayOnDevice;
